/** Returns hash code value of string
 *
 * @param inputValue String value to be hashed.
 * @returns {string} hash value
 */
const getHashCode = (inputValue) => {
	let hash = 0;
	let i;
	let chr;
	let len;
	if (inputValue.length === 0) {
		return hash;
	} else {
		for (i = 0, len = inputValue.length; i < len; i++) {
			chr = inputValue.charCodeAt(i);
			// eslint-disable-next-line no-bitwise
			hash = (hash << 5) - hash + chr;
			// eslint-disable-next-line no-bitwise
			hash |= 0;
		}
	}
	return Math.abs(hash);
};

export default getHashCode;
